import React from 'react';

const SixBlocks = ({col=2}) => {
  const blocks = [
    { icon: '/images/bank.svg', title: 'Service 1', text: 'Prix fixes' },
    { icon: '/images/user.svg', title: 'Service 2', text: 'Professionnels triés et qualifiés' },
    { icon: '/images/stopwatch.svg', title: 'Service 3', text: 'Prise de rdv en moins de 5min' },
    { icon: '/images/users.svg', title: 'Service 4', text: 'Une équipe d’experts à votre service 7j/7' },
    { icon: '/images/card-lock.svg', title: 'Service 5', text: 'Paiement 100% sécurisé par carte' },
    { icon: '/images/x-square.svg', title: 'Service 6', text: 'Annulation gratuite avant 48h' },
  ];

  return (
   
    <div className="row mt-5">
      {blocks.map((block, index) => (
        <div className={`col-md-${col} col-lg-${col}  mb-3`} key={index}>
          <div className="service-box">
            <img src={block.icon} alt={block.title} />
            <p className='mb-0'>{block.text}</p>
          </div>
        </div>
      ))}
    </div>
  
  );
};

export default SixBlocks;
